import { VSkeletonLoader, VCard } from "vuetify/lib";
import './styles.css';

export default {
  functional: true,
  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },
  render (_, context) {
    const { loading } = context.props || {};
    if (!loading) {
      return context.children;
    }
    return (
      <VCard class="card-glossary-skeleton-root" elevation="0">
        <VSkeletonLoader
          type="chip"
          class="card-glossary-skeleton-chip"
        />
        <VSkeletonLoader
          type="heading"
          class="card-glossary-skeleton-heading"
        />
        <VSkeletonLoader
          type="paragraph"
          class="card-glossary-skeleton-content"
        />
      </VCard>
    );
  }
};
